import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-workshop-jobcard-custom-questions-preview',
  templateUrl: './workshop-jobcard-custom-questions-preview.component.html',
  styleUrls: ['./workshop-jobcard-custom-questions-preview.component.scss']
})
export class WorkshopJobcardCustomQuestionsPreviewComponent {
  @Input() customQuestions: any[] = [];

  constructor(private translate: TranslateService) { }

  getQuestionsWithResponses() {
    return this.customQuestions
      .filter(group => group.customQuestions && group.customQuestions.length > 0)
      .map(group => ({
        ...group,
        customQuestions: group.customQuestions.filter(q => 
          q.response !== null && 
          q.response !== undefined && 
          q.response !== ''
        )
      }))
      .filter(group => group.customQuestions.length > 0);
  }

  formatResponse(question: any): string {
    if (question.controlType === 'CHECKBOX') {
      const isTrue = question.response === true || question.response === 'true';
      return isTrue 
        ? this.translate.instant('general.yes') 
        : this.translate.instant('general.no');
    }
    return question.response;
  }

}
